export default __webpack_public_path__ + "static/media/teamwork-upper.73911161.png";